// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline-banner-container[data-v-7695e884]{position:relative}.inline-error-banner[data-v-7695e884]{position:absolute;width:100%}", ""]);
// Exports
module.exports = exports;
